import User, { ErrorUser } from 'requests/objects/user'
// @ts-ignore
// eslint-disable-next-line import/no-cycle, import/named
import ApiHandler, { RequestApi } from 'requests/apiHandler'

/**
 * UsersHandler
 * @augments {ApiHandler<User, ErrorUser>}
 */
export default class UsersHandler extends ApiHandler {
    constructor() {
        super({ type: User, errorType: ErrorUser, key: 'users' })
    }

    /**
     * Authentificate User
     * @param {string} googleToken googleToken
     * @returns {RequestApi<User>} Request
     */
    login(googleToken) {
        const request = this.initFetchRequest({ url: ['login'], method: 'POST', data: { googleToken } })

        return this.getRequestApi(
            () => request.fetchRequest
                // eslint-disable-next-line new-cap
                .then(res => new (this.type)(res.data[this.objectName]))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * Authentificate User
     * @param {object} data data
     * @param {string} data.refreshToken refreshToken
     * @param {string} data.accessToken accessToken
     * @returns {RequestApi<User>} Request
     */
    logout({ refreshToken, accessToken }) {
        const request = this.initFetchRequest({
            url: ['logout'], method: 'POST', data: { refreshToken }, headers: { Authorization: `Bearer ${accessToken}` },
        })

        return this.getRequestApi(
            () => request.fetchRequest
                // eslint-disable-next-line new-cap
                .then(res => new (this.type)(res.data[this.objectName]))
                .catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * Authentificate User
     * @param {object} data data
     * @param {string} data.refreshToken refreshToken
     * @returns {RequestApi<User>} Request
     */
    refresh({ refreshToken }) {
        const request = this.initFetchRequest({ url: ['refresh'], method: 'PATCH', data: { refreshToken } })

        return this.getRequestApi(
            () => request.fetchRequest
                // eslint-disable-next-line new-cap
                .then(res => new (this.type)(res.data[this.objectName]))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }

    /**
     * Get informations about current user
     * @returns {RequestApi<User>} Request
     */
    getMe() {
        const request = this.initFetchRequest({ url: ['me'] })

        return this.getRequestApi(
            () => request.fetchRequest
                // eslint-disable-next-line new-cap
                .then(res => new (this.type)(res.data[this.objectName]))
                .catch(err => {
                    throw this.handleError(err)
                }),
            request.cancelToken,
        )
    }
}
